import {
  GET_GENERAL_META_DATA,
  GET_GENERAL_META_DATA_RESULT,
  GET_NEW_SESSION_ID,
  NEW_SESSION_ID_SUCCESS,
  ON_APP_LOAD,
  PLAY_KEYSTROKE,
  RECEIVE_TEXT_STREAM,
  RECEIVE_TEXT_STREAM_REFLECTED,
  PREDICT,
  SCROLL_TEXT,
  SET_ANIMATION,
  SET_END_OF_STREAM,
  SET_END_OF_STREAM_REFLECTED, SET_IS_SHOWING_NETWORK_STATS,
  SET_NETWORK_SPEED, SET_NETWORK_USAGE,
  SET_PLACEHOLDER_MESSAGE,
  SET_SHOULD_FOCUS_INPUT_FIELD,
  SET_SHOULD_FOCUS_SEND_BUTTON,
  STARTING_COMPLETION,
  TERMINATE,
  TURN_PLACEHOLDER_MESSAGE,
} from './consts'

export const predict = ({prompt, initiator}) => {
  if (!prompt) {
    throw new Error('action:Prompt is required')
  }
  if (!initiator) {
    throw new Error('action:Initiator is required')
  }
  return ({
    type: PREDICT,
    payload: prompt,
    initiator,
  });
}

export const receiveTextStream = ({word, predictionUUID, meta = []}) => ({
  type: RECEIVE_TEXT_STREAM,
  word,
  predictionUUID,
  meta
})

export const receiveTextStreamReflected = ({
                                             word,
                                             predictionUUID,
                                             meta = [],
                                             topN = null,
                                             selectedTopNIndex = -1,
                                             isTopNPanelOpen
                                           }) => ({
  type: RECEIVE_TEXT_STREAM_REFLECTED,
  word,
  predictionUUID,
  meta,
  topN,
  selectedTopNIndex,
  isTopNPanelOpen
})

export const startingCompletion = (prompt, initiator) => {
  if (!initiator) {
    console.error('startingCompletion action missing initiator', {prompt})
    throw new Error('startingCompletion: Initiator is required')
  }
  return {
    type: STARTING_COMPLETION,
    prompt,
    initiator,
  }
}

export const setAnimation = (animation) => ({
  type: SET_ANIMATION,
  payload: animation
})

export const setEndOfStream = ({endOfStream, predictionUUID}) => ({
  type: SET_END_OF_STREAM,
  endOfStream,
  predictionUUID
})

export const setEndOfStreamReflected = ({endOfStream, predictionUUID}) => ({
  type: SET_END_OF_STREAM_REFLECTED,
  endOfStream,
  predictionUUID
})

export const getGeneralMetaData = () => ({
  type: GET_GENERAL_META_DATA,
})

export const getGeneralMetaDataResult = (temp) => ({
  type: GET_GENERAL_META_DATA_RESULT,
  payload: temp,
})

export const onAppLoad = () => ({
  type: ON_APP_LOAD,
})

export const scrollText = () => ({
  type: SCROLL_TEXT,
})


export const playKeystroke = (isHumanKey = false) => ({
  type: PLAY_KEYSTROKE,
  isHumanKey,
})

export const terminate = () => ({
  type: TERMINATE,
})

export const setPlaceHolderMessage = (message) => ({
  type: SET_PLACEHOLDER_MESSAGE,
  message
})

export const turnPlaceHolderMessageAction = () => ({
  type: TURN_PLACEHOLDER_MESSAGE,
})

export const getNewSessionIdAction = () => ({
  type: GET_NEW_SESSION_ID,
})

export const newSessionIdSuccess = () => ({
  type: NEW_SESSION_ID_SUCCESS,
})

export const setShouldFocusSendButton = (shouldFocus = false) => ({
  type: SET_SHOULD_FOCUS_SEND_BUTTON,
  shouldFocus,
})

export const setShouldFocusInputField = (shouldFocus = false) => ({
  type: SET_SHOULD_FOCUS_INPUT_FIELD,
  shouldFocus,
})

export const setNetworkSpeed = (networkSpeed) => ({
  type: SET_NETWORK_SPEED,
  networkSpeed,
})
export const setNetworkUsage = (usage) => ({
  type: SET_NETWORK_USAGE,
  usage,
})

export const setIsShowingNetworkStats = (isShowing) => ({
  type: SET_IS_SHOWING_NETWORK_STATS,
  isShowing,
})
